@let referentiel = this.referentiel();
@if (referentiel) {
  <div class="flex h-full flex-col">
    <hlm-tabs tab="metier">
      <div class="px-lg border-neutral-light grid border-b bg-white">
        <div class="pt-lg flex items-center justify-between">
          <span class="title-medium-semibold">Périmètre</span>
          @if (estVerrouille()) {
            <app-chip label="Verrouillé" variant="warning" />
          }
        </div>
        <div>
          <hlm-tabs-list class="grid auto-cols-max grid-flow-col">
            <button hlmTabsTrigger="metier">Métier</button>
            <button hlmTabsTrigger="caracteristiques">Caractéristiques</button>
          </hlm-tabs-list>
        </div>
      </div>
      <section class="m-lg h-full overflow-y-auto bg-white !py-0" hlmCard>
        <div class="!p-lg" hlmCardContent>
          <div hlmTabsContent="metier">
            <app-perimetre-metier
              [famillesLivrables]="familles()"
              [cartographie]="cartographie()"
              [referentiel]="referentiel"
              [peutModifier]="peutModifier()"
            />
          </div>
          <div hlmTabsContent="caracteristiques">
            <app-perimetre-caracteristiques [referentiel]="referentiel" [peutModifier]="peutModifier()" />
          </div>
        </div>
      </section>
    </hlm-tabs>
  </div>
}
